import e from "react";
import { useTranslation as o } from "react-i18next";
function a() {
  const { t } = o();
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "i18n-test" }, t("testDoNotTouch"));
}
export {
  a as I18nTest
};
//# sourceMappingURL=I18nTest.js.map
